import { render, staticRenderFns } from "./BusinessRankingBI.vue?vue&type=template&id=f58f3d4a&"
import script from "./BusinessRankingBI.vue?vue&type=script&lang=js&"
export * from "./BusinessRankingBI.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRankingBI.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports